export default __webpack_public_path__ + "static/media/achive1.4acca1a8.jpg";